import React from 'react';
import DOMPurify from 'dompurify';

export const SafeHTML = ({ html }) => {
  // Sanitiza o HTML usando DOMPurify
  const sanitizedHTML = DOMPurify.sanitize(html);
  return <div dangerouslySetInnerHTML={{ __html: sanitizedHTML }} />;
  //return <>{sanitizedHTML}</>;
};


